<template>
  <div class="fee-breakdown-container" v-if="selectedUnits && selectedUnits.length">
    <div class="fee-breakdown-container__title">{{ container.title }}</div>
    <div class="fee-breakdown-container__body">

      <!-- If units show unit table -->
      <template v-if="units && units.length">
        <table class="table-fee-breakdown">
          <tbody>
            <template>
              <FeeUnitRow
                v-for="(item, index) in selectedItemsByLocation(location)"
                :key="item.relationship.code + '-' + index" :item="item" :seenUnits="seenUnits"/>
            </template>
          </tbody>
        </table>
      </template>

      <!-- If Container show containers -->
      <template v-if="containers && containers.length">
        <FeeUnitSubGroup v-for="(con,index) in containers" :key="index"
          :container="con" :location="getContainerLocation(con)"
          :seenUnits="seenUnits"/>
      </template>

      <template v-if="nonUnitRelationships && nonUnitRelationships.length">
        <template>
          <FeeUnitSubGroup v-for="(rel, index) in populatedNonUnitRelationships" :key="index"
            :relationship="rel" :location="getRelationshipLocation(rel)"
            :seenUnits="seenUnits"/>
        </template>
      </template>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dynamicSort } from 'common/helpers/dynamic-sort.js'
import SelectionLocationHelper from 'client/js/utils/selection-location-helper.js'

import FeeUnitSubGroup from './FeeUnitSubGroup.vue'
import FeeUnitRow from './FeeUnitRow.vue'

export default {
  props: {
    container: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    seenUnits: {
      type: Array,
      required: true
    }
  },
  methods: {
    getContainerLocation(container) {
      return SelectionLocationHelper.getContainerLocation(this.location, container)
    },
    getRelationshipLocation(relationship) {
      return SelectionLocationHelper.getRelationshipLocation(this.location, relationship)
    }
  },
  computed: {
    ...mapGetters({
      selectedItemsByLocation: 'units/getSelectedCurriculumItemByLocation'
    }),
    containers() {
      return this.container.container.slice().sort(dynamicSort('order'))
    },
    relationships() {
      return this.container.relationship.slice().sort(dynamicSort('order'))
    },
    selectedItems() {
      return this.selectedItemsByLocation(this.location) || []
    },
    selectedUnits() {
      return this.selectedItems.filter((i) => i.relationship.type === 'Unit')
    },
    units() {
      return this.relationships.filter((r) => r.type === 'Unit')
    },
    nonUnitRelationships() {
      return this.relationships.filter((r) => r.type !== 'Unit')
    },
    populatedNonUnitRelationships() {
      return this.nonUnitRelationships.filter((rel) => rel.structure && rel.structure.containers.length)
    }
  },
  mounted() {},
  components: { FeeUnitSubGroup, FeeUnitRow }
}
</script>
